export const tabletMaxWidth = 1100;
export const tabletQuery = `(max-width: ${tabletMaxWidth}px)`;
